module.exports = __webpack_public_path__ + "static/media/33000023.4d490f0e.png";